type ResponseHeaderCallback = (headerValue: string) => void

export const createFetchWithHeaderInterceptor = (
    baseFetch: typeof fetch,
    headerName: string,
    onHeaderDetected: ResponseHeaderCallback
): typeof fetch => {
    return async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
        const response = await baseFetch(input, init)
        const headerValue = response.headers.get(headerName)
        if (headerValue) {
            onHeaderDetected(headerValue)
        }
        return response
    }
}

export const WS3_SOFT_MODE_HEADER = 'ws3-soft-mode'
